import { instance } from "libs/api";

import { ApiRoutesDeliveryCompanies } from "../../constants";
import { DeliveryCompany } from "../../deliveryCompanies.types";

export interface ToggleDeliveryCompanyActiveRequestBody {
  id: string;
  isActive: boolean;
}

export const requestToggleDeliveryCompanyActive = async ({
  id,
  isActive
}: ToggleDeliveryCompanyActiveRequestBody): Promise<DeliveryCompany> => {
  return await instance.put(
    `${ApiRoutesDeliveryCompanies.CompaniesActive}/${id}/${isActive}`
  );
};
